export const UserRolesMixin = {
  async created() {},
  data() {
    return {}
  },
  computed: {
    isSuperAdmin() {
      return this.$store.state.UserStore.userRole[0] === 'super_admin'
    }
  },
  methods: {
    async isAllowedOnResource(resource, permission, projectId) {
      //let isAllowed = await UsersService.isAllowedOnResource(resource)
      let params = {
        resourceName: resource,
        permission: permission
      }
      if (projectId) {
        params.projectId = projectId
      }
      let isAllowed = await this.$store.dispatch('UserStore/isAllowed', params)
      return isAllowed
    }
  }
}
